import _ from "lodash";
import { Switch, Tag, Typography } from "antd";
import Highlighter from "react-highlight-words";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { memo } from "react";

const { Text } = Typography;

const RenderRow = (props, ref) => {
  const { searchKey } = useSelector((state) => state.objectsReducer);

  //custom render
  if (_.get(props, "item.type") === "switchColumn") {
    return (
      <div style={{ textAlign: "center" }}>
        <CustomSwitch
          defaultChecked={_.get(props, "value")}
          onChange={(checked) =>
            props.onChangeSwitch &&
            props.onChangeSwitch(checked, _.get(props, "data"))
          }
        />
      </div>
    );
  }

  if (_.get(props, "item.type") === "droplist") {
    if (_.get(props, "item.multiple")) {
      return (
        <TextComponent
          ellipsis={{
            tooltip:
              _.get(props, "value") || _.get(props, "value") === 0
                ? _.get(props, "value", "").join(", ")
                : "",
          }}
        >
          {_.get(props, "value", []) &&
            _.size(_.get(props, "value", [])) > 0 &&
            _.get(props, "value", []).map((item) => <Tag>{item}</Tag>)}
        </TextComponent>
      );
    } else {
      return (
        <HighlighterCustom>
          <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={
              typeof searchKey[_.get(props, "item.ID")] === "object"
                ? _.get(searchKey, `[${_.get(props, "item.ID")}]`, []).map(
                    (item) => {
                      if (item === _.get(props, "value.raw_value")) {
                        return _.get(props, "value.value");
                      }

                      return item;
                    }
                  )
                : []
            }
            autoEscape={true}
            textToHighlight={
              _.get(props, "value")
                ? _.get(props, "value.raw_value")
                  ? _.get(props, "value.value", "").toString()
                  : _.get(props, "value", "").toString()
                : ""
            }
          />
        </HighlighterCustom>
      );
    }
  }
  //
  return (
    <HighlighterCustom IsNumber={_.get(props, "item.type") === "number"}>
      {_.get(props, "item.type") === "file" ||
      (_.get(props, "item.type") === "select" &&
        _.get(props, "item.multiple")) ? (
        <TextComponent
          ellipsis={{
            tooltip:
              _.get(props, "value") || _.get(props, "value") === 0
                ? _.get(props, "value", "").toString()
                : "",
          }}
        >
          {props.renderFieldFile
            ? props.renderFieldFile(_.get(props, "value"), _.get(props, "item"))
            : _.get(props, "value")}
        </TextComponent>
      ) : (
        <TextComponent
          ellipsis={{
            tooltip:
              _.get(props, "value") || _.get(props, "value") === 0
                ? _.get(props, "value", "").toString()
                : "",
          }}
          className={_.get(props, "item.type") === "id" ? "underline" : ""}
        >
          {/* {_.get(props, "item.type") === "id" && (
            <CustomImg
              alt=""
              src="https://lab.connect247.vn/ucrmapi-sso/media/tnt_callfinesse_59890767/brand_name/download.png"
            />
          )} */}
          {(_.get(props, "item.type") === "number" &&
            _.get(props, "value") !== null) ||
          (_.get(props, "item.type") === "formula" &&
            _.get(props, "item.formula_type") === "advanceExpression" &&
            _.get(props, "value") !== null) ? (
            props.numberWithCommas ? (
              props.numberWithCommas(
                _.get(props, "value"),
                _.get(props, "item")
              )
            ) : (
              _.get(props, "value")
            )
          ) : (
            <Highlighter
              highlightClassName="YourHighlightClass"
              searchWords={
                typeof searchKey[_.get(props, "item.ID")] === "object"
                  ? searchKey[_.get(props, "item.ID")]
                  : [
                      typeof searchKey[_.get(props, "item.ID")] === "number"
                        ? searchKey[_.get(props, "item.ID")] &&
                          searchKey[_.get(props, "item.ID")].toString()
                        : searchKey[_.get(props, "item.ID")],
                    ] || []
              }
              autoEscape={true}
              textToHighlight={
                _.get(props, "value") || _.get(props, "value") === 0
                  ? _.get(props, "value", "").toString()
                  : ""
              }
            />
          )}
        </TextComponent>
      )}
    </HighlighterCustom>
  );
};

export default memo(RenderRow);

// const CustomImg = styled(Image)`
//   width: 25px;
//   height: 25px;
//   object-fit: cover;
//   border-radius: 50%;
//   margin-right: 4px;
// `;

const TextComponent = styled(Text)`
  color: inherit !important;

  /* &.underline {
    text-decoration: underline;
  } */
`;

const HighlighterCustom = styled.div`
  mark {
    background-color: #ffd54f !important;
    padding: 0;
  }
  text-align: ${({ IsNumber }) => (IsNumber ? "right" : "left")};
`;

const CustomSwitch = styled(Switch)`
  &.ant-switch-checked {
    background-color: ${(props) => props.theme.main};
  }
`;
